import React from "react";
import  {
  Page,
  Text,
  View,
  Document,
  BlobProvider,
} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Spin } from "antd";
import { memberlist_styles as styles, PDFSaved} from './PDF_Helper'

const DisplayContent = props => {
  let i = 0 
  return props.data.map(item => {

    let thisStyle = styles.detailContainerGray
    i += 1
    if (i % 2) thisStyle = styles.detailContainer

      return (
        <View key={item.offeringNo} style={thisStyle} wrap={false} >
              <Text style={[styles.engDetails, { width:'40px'}]}>
              {item.offeringNo}
              </Text>
              <Text style={[styles.chnDetails, { width:'200px'}] }>
              {item.displayName}
              </Text>
              <Text style={styles.engDetails}>
              {item.address}
              </Text>
        </View>
      );
    });
  };
  

  const Heading = props => {
      let OrgName = sessionStorage.getItem("OrganisationName");
      let Address = sessionStorage.getItem("Address");
      return (
        <View key='heading' style={styles.content} wrap={false}>
          <Text style={styles.heading}>{OrgName}</Text>
          <Text style={styles.address}>{Address}</Text>
          <Text style={styles.title}>Member list</Text>
        </View>
      );
    }


  const GetPDF = props => {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Heading/>
          <DisplayContent data={props.data} />
          <Text
            style={styles.footer}
            render={({ pageNumber }) => `Page ${pageNumber}`}
            fixed
          />
        </Page>
      </Document>
    );
  };
  


export default function GenmemberListPDF(props) {
    //console.log('GenmemberListPDF ready: ' + props.ready)
    if (props.ready) {
      return (
        <BlobProvider document={<GetPDF data={props.data} />}>
          {({ blob, url, loading, error }) => {
            if (!loading && url) {
              saveAs(blob, `member_list.pdf`);
              return <PDFSaved doFinish={props.doFinish} />;
            }
            if (loading) {
              return <Spin tip="loading" spinning={true} />;
            }
            if (error) {
              //console.error(error);
              return <p>An error occurred</p>;
            }
            return null;
          }}
        </BlobProvider>
      );
    }
    return null;
  }